
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'LazyClientShow',
})
export default class LazyClientShow extends Vue {
	isMounted = false;

	@Prop({ default: 'never' }) hydrate: 'when-idle' | 'when-visible' | 'never' | 'on-interaction';
	// sometimes we want to have it rendered on the server too, so we have the component in the HTML already.
	@Prop({ default: false }) forceRenderOnServer: boolean;
	@Prop({ default: () => ({ rootMargin: '100%' }) }) intersectionOptions: Record<string, string>;

	mounted() {
		this.isMounted = true;
	}

	get shouldRenderSlot() {
		return this.isMounted || this.forceRenderOnServer;
	}
}
